import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { DashboardDataProvider } from "../../data-provider/dashboard.dp";
import { Dashboard } from "../../models/dashboard.model";
import { PermissionCheck } from "../../shared/permission";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { ToastUtils } from "../../helper/toast.helper";
import { User } from "../../models/user.model";
import { UserDataProvider } from "../../data-provider/user.dp";

let DashboardActionsComponent = {
    selector: "vcDashboardActions",
    templateUrl:
        "/angular/components/dashboard/dashboard-actions.component.html",
    bindings: {
        dashboard: "=",
        dashboards: "=",
        loading: "=?",
        size: "=?",
        mode: "=?",
    },
    controller: class DashboardActionsController {
        // * bindings for typescript compiler *
        public dashboard: Dashboard;
        public dashboards: Dashboard[];
        public loading?: Dashboard;
        public mode?: string;
        public size: string;
        // ************************************

        private readonly $scope: any;
        private readonly $window: any;
        private permissionProvider: PermissionCheck;
        private dialog: DialogUtils;
        private toast: ToastUtils;
        private dataProvider: DashboardDataProvider;

        public isLeaderView: boolean;
        public campaignDataProvider: CampaignDataProvider;
        public isUserDashboard: boolean;
        public dashboardWord: string;
        public user: User;

        constructor(
            $scope: any,
            $window: any,
            PermissionCheck: PermissionCheck,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            DashboardDataProvider: DashboardDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            UserDataProvider: UserDataProvider,
            __app_type: string
        ) {
            this.$scope = $scope;
            this.$window = $window;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.toast = ToastUtils;
            this.permissionProvider = PermissionCheck;
            this.dataProvider = DashboardDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.user = UserDataProvider.getActiveUser();
            this.isLeaderView = __app_type == "LEADER";
        }

        $onInit() {
            if (!this.dashboard) {
                this.dashboard = new Dashboard();
            }
            if (!this.size) {
                this.size = "default";
            }
            this.isUserDashboard = this.dashboard.location == "user";
            this.dashboardWord = this.isUserDashboard
                ? "User Dashboard "
                : "Dashboard";

            if (!this.size) {
                this.size = "default";
            }
        }

        enableSampleData($event) {
            this.campaignDataProvider.restoreSampleData().then(() => {
                this.$window.location.reload();
            });
        }

        deleteDashboard(dashboard: Dashboard, ev: any) {
            this.dialog
                .delete({
                    targetEvent: ev,
                    locals: {
                        title: "Delete Dashboard?",
                        bodyText:
                            "You will no longer be able to use this dashboard",
                    },
                })
                .then(() => {
                    // this.loadingDashboard = true;
                    this.dataProvider.delete(dashboard).then(
                        (dashboard: any): void => {
                            this.toast.success("Dashboard deleted");
                            angular.forEach(
                                this.dashboards,
                                (thisDashboard: Dashboard, $index: number) => {
                                    if (
                                        thisDashboard.id &&
                                        dashboard.id == thisDashboard.id
                                    ) {
                                        this.dashboards.splice($index, 1);
                                    }
                                }
                            );
                            if (this.dashboards.length > 0) {
                                this.dashboard = this.dashboards[0];
                            } else {
                                this.dashboard = null;
                            }
                        },
                        (error: any): void => {
                            console.log(error);
                        }
                    );
                });
        }

        createDashboard(ev: any, dashboard?: Dashboard, duplicate?: boolean) {
            let data: Dashboard | null = dashboard
                ? angular.copy(dashboard)
                : null;
            this.dialog
                .show({
                    component: "vc-create-dashboard",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    ariaLabel: "Create New " + this.dashboard.referenceName(),
                    locals: {
                        dashboard: data,
                        duplicate: duplicate,
                        location: this.mode,
                    },
                })
                .then((returnedDashboard: Dashboard) => {
                    if (dashboard && !duplicate) {
                        dashboard.setData(returnedDashboard);
                        this.toast.success(
                            this.dashboard.referenceName() + " updated"
                        );
                    } else {
                        this.dashboard = returnedDashboard;
                        this.toast.success(
                            this.dashboard.referenceName() + " created"
                        );
                        this.dashboards.push(this.dashboard);
                    }
                });
        }

        downloadCanvasses(ev: any) {
            if (this.permissionProvider.hasPermission("EXPORT")) {
                if (this.isLeaderView) {
                    this.dialog.show({
                        component: "vc-organisation-result-export",
                        targetEvent: ev,
                        scope: this.$scope,
                        locals: {
                            survey: null,
                        },
                        size: "large",
                        ariaLabel: "Export Data",
                    });
                } else {
                    this.dialog.show({
                        component: "vc-result-export-dialog",
                        size: "large",
                        targetEvent: ev,
                        scope: this.$scope,
                        locals: {
                            survey: null,
                        },
                    });
                }
            } else {
                this.dialog.show({
                    component: "vc-export-disabled-dialog",
                    size: "large",
                    scope: this.$scope,
                });
            }
        }
    },
};

angular
    .module("dashboard")
    .component(DashboardActionsComponent.selector, DashboardActionsComponent);
